// extracted by mini-css-extract-plugin
export default {"documentMessage":"tf88saiUsY849Ag51tXW","documentMessageFilename":"yOUoNHcm3ld8v_UoAB4C"};